
// src/components/settings/CompanySettingsTabs.jsx
import React from "react";
import UploadField from "./UploadField";

export default function CompanySettingsTabs({
  formData,
  handleChange,
  handleFileChange,
  saving,
  onSubmit,
}) {
  const tabs = [
    { id: "basics", label: "Basics" },
    { id: "contact", label: "Contact & Address" },
    { id: "compliance", label: "Compliance" },
    { id: "branding", label: "Branding & Uploads" },
    { id: "financial", label: "Financial & Notifications" },
  ];

  const [activeTab, setActiveTab] = React.useState("basics");

  return (
    <div>
      {/* Tabs Navigation */}
      {/* <div className="border-b border-gray-200 dark:border-gray-700">
        <nav className="-mb-px flex space-x-8 px-6 overflow-x-auto" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap
                ${activeTab === tab.id
                  ? "border-indigo-500 text-indigo-600 dark:border-indigo-400 dark:text-indigo-400"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300"}`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div> */}
      <div className="border-b border-gray-800">
  <nav className="-mb-px flex space-x-10 px-8 overflow-x-auto">
    {tabs.map((tab) => (
      <button
        key={tab.id}
        onClick={() => setActiveTab(tab.id)}
        className={`py-5 px-2 border-b-2 font-semibold text-base whitespace-nowrap transition-colors
          ${activeTab === tab.id
            ? "border-orange-500 text-orange-400"
            : "border-transparent text-gray-500 hover:text-gray-300 hover:border-gray-600"}`}
      >
        {tab.label}
      </button>
    ))}
  </nav>
</div>

      {/* Tab Content */}
      {/* <div className="p-6">
        <form onSubmit={onSubmit} className="space-y-8"> */}
        <div className="p-8">
  <form onSubmit={onSubmit} className="space-y-10">
          {/* Basics Tab */}
          {activeTab === "basics" && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Legal Name *
                </label>
                <input
                  type="text"
                  name="legal_name"
                  value={formData.legal_name}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white px-3 py-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Trade Name
                </label>
                <input
                  type="text"
                  name="trade_name"
                  value={formData.trade_name}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white px-3 py-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Company Code (auto-generated)
                </label>
                <input
                  type="text"
                  value={formData.company_code || "Will be auto-generated"}
                  disabled
                  className="mt-1 block w-full rounded-md border-gray-300 bg-gray-100 shadow-sm px-3 py-2 sm:text-sm dark:bg-gray-600 dark:text-gray-300 cursor-not-allowed"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Status
                </label>
                <select
                  name="is_active"
                  value={formData.is_active}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 sm:text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                >
                  <option value={true}>Active</option>
                  <option value={false}>Inactive</option>
                </select>
              </div>
            </div>
          )}

          {/* Contact & Address Tab */}
          {activeTab === "contact" && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Primary Address *
                </label>
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  rows={4}
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Shipping Address (if different)
                </label>
                <textarea
                  name="shipping_address"
                  value={formData.shipping_address}
                  onChange={handleChange}
                  rows={4}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Pincode
                </label>
                <input
                  type="text"
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  State
                </label>
                <input
                  type="text"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Primary Phone *
                </label>
                <input
                  type="tel"
                  name="primary_phone"
                  value={formData.primary_phone}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Alternate Phone
                </label>
                <input
                  type="tel"
                  name="alternate_phone"
                  value={formData.alternate_phone}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Landline
                </label>
                <input
                  type="tel"
                  name="landline"
                  value={formData.landline}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Primary Email *
                </label>
                <input
                  type="email"
                  name="primary_email"
                  value={formData.primary_email}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Support Email
                </label>
                <input
                  type="email"
                  name="support_email"
                  value={formData.support_email}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Accounts Email
                </label>
                <input
                  type="email"
                  name="accounts_email"
                  value={formData.accounts_email}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Website
                </label>
                <input
                  type="url"
                  name="website"
                  value={formData.website}
                  onChange={handleChange}
                  placeholder="https://example.com"
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>
            </div>
          )}

          {/* Compliance Tab */}
          {activeTab === "compliance" && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  GSTIN
                </label>
                <input
                  type="text"
                  name="gstin"
                  value={formData.gstin}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
                {/* <label className="mt-2 flex items-center gap-2">
                  <input
                    type="checkbox"
                    name="enable_gstin"
                    checked={formData.enable_gstin}
                    onChange={handleChange}
                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                  />
                  <span className="text-sm text-gray-700 dark:text-gray-300">Enable GSTIN</span>
                </label> */}
                <label className="flex items-center gap-3 cursor-pointer group">
  <input
    type="checkbox"
    name="enable_gstin"
    checked={formData.enable_gstin}
    onChange={handleChange}
    className="h-5 w-5 rounded border-gray-600 text-orange-500 
               focus:ring-orange-500/30 bg-gray-800"
  />
  <span className="text-sm font-medium text-gray-300 group-hover:text-orange-400 transition-colors">
    Enable GSTIN
  </span>
</label>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  PAN
                </label>
                <input
                  type="text"
                  name="pan"
                  value={formData.pan}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
                <label className="mt-2 flex items-center gap-2">
                  <input
                    type="checkbox"
                    name="enable_pan"
                    checked={formData.enable_pan}
                    onChange={handleChange}
                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                  />
                   <span className="text-sm font-medium text-gray-300 group-hover:text-orange-400 transition-colors">
                Enable PAN</span>
                </label>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  TAN
                </label>
                <input
                  type="text"
                  name="tan"
                  value={formData.tan}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
                <label className="mt-2 flex items-center gap-2">
                  <input
                    type="checkbox"
                    name="enable_tan"
                    checked={formData.enable_tan}
                    onChange={handleChange}
                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                  />
      <span className="text-sm font-medium text-gray-300 group-hover:text-orange-400 transition-colors">Enable TAN</span>
                </label>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  CIN
                </label>
                <input
                  type="text"
                  name="cin"
                  value={formData.cin}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
                <label className="mt-2 flex items-center gap-2">
                  <input
                    type="checkbox"
                    name="enable_cin"
                    checked={formData.enable_cin}
                    onChange={handleChange}
                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                  />
                 <span className="text-sm font-medium text-gray-300 group-hover:text-orange-400 transition-colors">Enable CIN</span>
                </label>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  IEC (Import Export Code)
                </label>
                <input
                  type="text"
                  name="iec"
                  value={formData.iec}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
                <label className="mt-2 flex items-center gap-2">
                  <input
                    type="checkbox"
                    name="enable_iec"
                    checked={formData.enable_iec}
                    onChange={handleChange}
                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                  />
                <span className="text-sm font-medium text-gray-300 group-hover:text-orange-400 transition-colors">Enable IEC</span>
                </label>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  MSME / Udyam Number
                </label>
                <input
                  type="text"
                  name="msme_udyam"
                  value={formData.msme_udyam}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
                <label className="mt-2 flex items-center gap-2">
                  <input
                    type="checkbox"
                    name="enable_msme"
                    checked={formData.enable_msme}
                    onChange={handleChange}
                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                  />
             <span className="text-sm font-medium text-gray-300 group-hover:text-orange-400 transition-colors">Enable MSME</span>
                </label>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  ISO Number
                </label>
                <input
                  type="text"
                  name="iso_number"
                  value={formData.iso_number}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
                <label className="mt-2 flex items-center gap-2">
                  <input
                    type="checkbox"
                    name="enable_iso"
                    checked={formData.enable_iso}
                    onChange={handleChange}
                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                  />
            <span className="text-sm font-medium text-gray-300 group-hover:text-orange-400 transition-colors">Enable ISO</span>
                </label>
              </div>

              {/* <div className="md:col-span-2"> */}
                {/* <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Extra Registrations (JSON)
                </label> */}
                {/* <textarea
                  name="extra_registrations"
                  value={JSON.stringify(formData.extra_registrations || {}, null, 2)}
                  onChange={(e) => {
                    try {
                      const parsed = JSON.parse(e.target.value);
                      handleChange({ target: { name: "extra_registrations", value: parsed } });
                    } catch (err) {
                      // Invalid JSON - ignore silently or add error state
                    }
                  }}
                  rows={6}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 font-mono text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  placeholder='{"udaan": "UDN-456789", "fssai": "12345678901234"}'
                /> */}
              {/* </div> */}
            </div>
          )}

          {/* Branding & Uploads Tab */}
          {activeTab === "branding" && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <UploadField
                label="Primary Logo"
                name="logo_primary"
                currentUrl={formData.logo_primary}
                onChange={handleFileChange}
                accept=".png,.jpg,.jpeg,.svg"
              />

              <UploadField
                label="Secondary Logo (optional)"
                name="logo_secondary"
                currentUrl={formData.logo_secondary}
                onChange={handleFileChange}
                accept=".png,.jpg,.jpeg,.svg"
              />

              <UploadField
                label="Letterhead File (PDF/Image)"
                name="letterhead_file"
                currentUrl={formData.letterhead_file}
                onChange={handleFileChange}
                accept=".pdf,.jpg,.jpeg,.png"
              />

              <UploadField
                label="UPI QR Code"
                name="upi_qr_code"
                currentUrl={formData.upi_qr_code}
                onChange={handleFileChange}
                accept=".png,.jpg,.jpeg"
              />
            </div>
          )}

          {/* Financial & Notifications Tab */}
          {activeTab === "financial" && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Invoice Prefix
                </label>
                <input
                  type="text"
                  name="invoice_prefix"
                  value={formData.invoice_prefix}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Quotation Prefix
                </label>
                <input
                  type="text"
                  name="quotation_prefix"
                  value={formData.quotation_prefix}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Purchase Order Prefix
                </label>
                <input
                  type="text"
                  name="purchase_order_prefix"
                  value={formData.purchase_order_prefix}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Default Currency
                </label>
                <input
                  type="text"
                  name="default_currency"
                  value={formData.default_currency}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Tax Label
                </label>
                <input
                  type="text"
                  name="tax_label"
                  value={formData.tax_label}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Default Tax Rate (%)
                </label>
                <input
                  type="number"
                  step="0.01"
                  name="default_tax_rate"
                  value={formData.default_tax_rate}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div className="flex items-center gap-3">
                <input
                  type="checkbox"
                  name="enable_gst"
                  checked={formData.enable_gst}
                  onChange={handleChange}
                  className="h-5 w-5 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                />
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  Enable GST Features
                </label>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Financial Year Start Month
                </label>
                <select
                  name="financial_year_start_month"
                  value={formData.financial_year_start_month}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 sm:text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                >
                  <option value={1}>January</option>
                  <option value={2}>February</option>
                  <option value={3}>March</option>
                  <option value={4}>April (Indian FY)</option>
                  <option value={5}>May</option>
                  <option value={6}>June</option>
                  <option value={7}>July</option>
                  <option value={8}>August</option>
                  <option value={9}>September</option>
                  <option value={10}>October</option>
                  <option value={11}>November</option>
                  <option value={12}>December</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                  Low Stock Threshold
                </label>
                <input
                  type="number"
                  name="low_stock_threshold"
                  value={formData.low_stock_threshold}
                  onChange={handleChange}
                  className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                />
              </div>

              <div className="flex items-center gap-3">
                <input
                  type="checkbox"
                  name="enable_notifications"
                  checked={formData.enable_notifications}
                  onChange={handleChange}
                  className="h-5 w-5 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                />
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  Enable System Notifications
                </label>
              </div>
            </div>
          )}

          {/* Submit Button */}
          <div className="mt-12 flex justify-end">
            {/* <button
              type="submit"
              disabled={saving}
              className={`px-10 py-4 bg-indigo-600 text-white font-semibold rounded-xl shadow-lg
                ${saving ? "opacity-60 cursor-not-allowed" : "hover:bg-indigo-700 transition-transform transform hover:scale-105"}`}
            >
              {saving ? (
                <span className="flex items-center gap-2">
                  <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Saving...
                </span>
              ) : (
                "Save All Settings"
              )}
            </button> */}
            <button
  type="submit"
  disabled={saving}
  className={`px-5 py-3 bg-orange-600 text-white font-bold text-lg rounded-xl shadow-xl shadow-orange-900/40
    transition-all duration-200
    ${saving 
      ? "opacity-60 cursor-not-allowed" 
      : "hover:bg-orange-500 hover:shadow-orange-700/50 hover:scale-[1.02] active:scale-100"}`}
>
  {saving ? (
    <span className="flex items-center justify-center gap-3">
      <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
      Saving...
    </span>
  ) : (
    "Save All Settings"
  )}
</button>
          </div>
        </form>
      </div>
    </div>
  );
}